import { useEffect, useState } from 'react';
import { APIS } from '../../config/apis';
import { REQUEST_METHOD } from '@laramie/ui';
import { ServerRequest } from '../../utils/apiweb';


export const useCatalogosVariable = () => {

    const [catalogos, setCatalogos] = useState([]);

    useEffect(() => {
        const callbackSuccess = (response) => {
            response.json()
            .then((data) => {
                setCatalogos(data.map(x => ({ key: x.codigo, value: x.nombre })));
            })
            .catch(() => {});
        };
        const callbackError = () => {};

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.VARIABLE_LISTA,
            null,
            null,
            callbackSuccess,
            callbackError,
            callbackError
        );
    }, []);

    return catalogos;
}
